// pass  276403

const constantApi = {
  baseUrl: "https://api.jtserp.cloud/api",
  imageUrl: "https://api.jtserp.cloud/uploads",

  // baseUrl: "http://localhost:5610/api",
  // imageUrl: "http://localhost:5610/uploads",

  // Any other services (if needed)
  tripUrl: "http://localhost:5173/services", // keep local if still used during development
};
export default constantApi;
